<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="权益申请"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-form @submit="onSubmit">
        <div class="batch-item">
        <!--   球杆序列号     -->
        <van-field
            readonly
            clickable
            name="number"
            :value="formData.oldNumber"
            label="球杆序列号"
            placeholder="点击选择序列号"
            @click="showPicker = true"
            class="search-input"
            :rules="[{ required: true}]"
        />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectOptions"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
          </van-popup>
          <van-field v-if="formData.oldNumber" readonly v-model="formData.oldBrand" name="oldBrand" label="品牌" />
          <van-field v-if="formData.oldNumber" readonly v-model="formData.oldModel" name="oldModel" label="型号" />
        <!--   权益     -->
        <van-field
            readonly
            clickable
            name="newName"
            :value="formData.newName"
            label="球杆品类"
            placeholder="点击选择球杆品类"
            @click="openBenefitsPicker"
            class="search-input"
            :rules="[{ required: true}]"
        />
        <van-popup v-if="showBenefitsPicker" v-model="showBenefitsPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="selectBenefitsOptions"
              @confirm="onBenefitsConfirm"
              @cancel="showBenefitsPicker = false"
          />
        </van-popup>
        <van-field v-if="isChildren && type == '1'" name="isColor" label="是否跨色置换">
          <template #input>
            <van-radio-group v-model="formData.isColor" direction="horizontal">
              <van-radio name="0">否</van-radio>
              <van-radio name="1">是</van-radio>
            </van-radio-group>
          </template>
        </van-field>


          <van-field
              v-if="isChildren && type == '1' && formData.isColor=='1' "
              readonly
              clickable
              name="colorName"
              :value="formData.colorName"
              label="跨色品类"
              placeholder="点击选择跨色品类"
              @click="openColorPicker"
              class="search-input"
              :rules="[{ required: true}]"
          />
          <van-popup v-if="showColorPicker" v-model="showColorPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectColorOptions"
                @confirm="onColorConfirm"
                @cancel="showColorPicker = false"
            />
          </van-popup>

        <van-field name="fileList" label="旧杆图片"  :rules="[{ required: true, message: '请上传旧杆图片' }]">
          <template #input>
            <van-uploader v-model="formData.fileList" multiple :max-count="3" />
          </template>
        </van-field>

          <van-field
              v-model="formData.storeName"
              is-link
              readonly
              label="门店"
              placeholder="请选择门店(选填)"
              @click="showStoreProvCityPicker = true"
          />
          <van-popup v-if="showStoreProvCityPicker" v-model="showStoreProvCityPicker" round position="bottom">
            <van-cascader
                v-model="formData.storeName"
                title="请选择所在地区"
                :options="storeProvCityOptions"
                @close="showStoreProvCityPicker = false"
                @finish="onFinish"
            />
          </van-popup>
          <van-field v-if="formData.storeId" v-model="formData.menPhone" name="menPhone" label="门店电话" readonly/>
          <van-field v-if="formData.storeId" v-model="formData.menAddress" name="menAddress" label="详细地址" readonly type="textarea" rows="3" />

        <van-field v-model="formData.phonenumber" name="phonenumber" label="联系电话" placeholder="请输入联系电话" :rules="[{ validator:telValidator }]"/>
        <van-field v-model="formData.address" name="address" label="通讯地址" placeholder="请输入通讯地址" type="textarea" rows="3" />

<!--        <van-field-->
<!--            readonly-->
<!--            clickable-->
<!--            name="area"-->
<!--            :value="provinceValue"-->
<!--            label="地址"-->
<!--            placeholder="点击选择省市区"-->
<!--            @click="showArea = true"-->
<!--            :rules="[{ required: true }]"-->
<!--        />-->
<!--        <van-popup v-if="showArea" v-model="formData.province" position="bottom">-->
<!--          <van-area-->
<!--              :area-list="areaList"-->
<!--              @confirm="onCityConfirm"-->
<!--              @cancel="showArea = false"-->
<!--          />-->
<!--        </van-popup>-->

<!--        <van-field v-model="formData.detailAddr"-->
<!--                   name="detailAddr"-->
<!--                   rows="1"-->
<!--                   autosize-->
<!--                   type="textarea"-->
<!--                   label="详细地址"-->
<!--                   placeholder="请输入您的详细地址"-->
<!--                   :rules="[{ required: true }]"-->
<!--        />-->

        <div style="margin: 16px;">
          <van-button class="submit-btn" round block type="info" native-type="submit">提交申请</van-button>
        </div>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {Dialog, Toast} from "vant";
import { areaList } from '@vant/area-data';
import {
  memberEquitiesUse, memberEquitiesUseCheck,
  seriesOfCueSticks,
  useBenefitsStoreById,
  useBenefitsStoreProvCity
} from "@/api/mine";
import {benefitsSubmit} from "@/api/sales";

export default {
  data(){
    return {
      // 表单数据
      formData: {
        phonenumber: '',       // 联系电话
        address: '',     // 通讯地址
        oldNumber: '',   // 球杆编号
        oldBrandCode: '',//品牌
        oldBrand: '',
        oldModelCode: '',//型号
        oldModel: '',
        newId: '',//福利id
        newName: '',//福利名称
        type: '',//类型 1、置换 2、翻新

        //门店信息
        storeId:'',
        storeName:'',

        menAddress:'',
        menPhone:'',

        isColor: '0',
        colorId: '',//跨色福利id
        colorName: '',//跨色福利名称
        fileList: [],
      },

      seriesId:'',
      type:'',
      selectOptions: [],
      showPicker: false,

      //权益接口返回数据
      benefitsList: [],
      //权益下拉值
      selectBenefitsOptions: [],
      showBenefitsPicker: false,
      //跨色权益

      isChildren: false,
      selectColorOptions: [],
      showColorPicker: false,

      myClubList:[],
      selectClubForm:{},

      provinceValue: '',
      showArea: false,
      areaList,
      fileList: [],

      //门店数据
      storeProvCityOptions: [],
      showStoreProvCityPicker: false,
    }
  },
  watch:{
    "$route.query": {
      immediate: true, // 初始化时立即执行
      handler(newQuery) {
        const { seriesId,type } = newQuery;
        if (seriesId && type) {
          this.seriesId = seriesId;
          this.type = type;
          this.selectProductByUser(seriesId);
        } else {
          Toast("参数不能为空");
        }
      },
    },
  },
  created() {
    this.getUseBenefitsStoreProvCity();
  },
  methods: {
    onFinish({ selectedOptions }) {
      this.showStoreProvCityPicker = false;

      this.formData.storeId = selectedOptions[2].value;
      this.formData.storeName = selectedOptions[2].text;

      if(this.formData.storeId){
        this.getStoreById(this.formData.storeId);
      }
    },
    //获取有置换翻新的门店信息
    getUseBenefitsStoreProvCity(){
      useBenefitsStoreProvCity().then(res => {
        if (res.code === 200) {
          if(res.data){
            this.storeProvCityOptions = res.data;
          }
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg,
          }).then(() => {
            // on close
          });
        }
      })
    },
    //获取门店详细信息
    getStoreById(storeId){
      useBenefitsStoreById(storeId).then(res => {
        if (res.code === 200) {
          if(res.data){
            this.formData.menPhone = res.data.menPhone;
            this.formData.menAddress = res.data.menAddress;
          }
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg,
          }).then(() => {
            // on close
          });
        }
      })
    },
    //权益点击事件
    openBenefitsPicker(){
      if(!this.formData.oldNumber){
        Toast("请先选择球杆序列号！");
      }else{
        this.memberEquitiesUse();
        // this.showBenefitsPicker = true;
      }
    },
    //打开跨色点击事件
    openColorPicker(){
      if(!this.formData.oldNumber){
        Toast("请先选择球杆序列号！");
      }else if(!this.formData.newId){
        Toast("请先选择球杆品类！");
      }else{
        const filterList = this.benefitsList.filter(item => item.id === this.formData.newId)[0].children ||[];
        if(filterList){
          filterList.forEach(item => {
            this.selectColorOptions.push({
              value: item.relationId,
              text: item.name,
            })
          })
        }
        this.showColorPicker = true;
      }
    },
    //获取福利
    memberEquitiesUse(){
      memberEquitiesUse(this.type,this.seriesId,this.formData.oldNumber,).then(res => {
        if (res.code === 200) {
          if(res.data){
            this.showBenefitsPicker = true;
            this.selectBenefitsOptions = [];
            res.data.forEach(item => {
              if(item.children && item.children.length>0){
                item.isChildren =true;
              }else{
                item.isChildren =false;
              }
              this.benefitsList.push(item);
              this.selectBenefitsOptions.push({
                text: item.name,
                value: item.id,
              });
            })
          }
        } else {
          this.showBenefitsPicker = false;
          this.showDialogMsg(res.returnMsg)
        }
      })
    },
    //权益校验
    memberEquitiesUseCheck(benefits,  number){
      memberEquitiesUseCheck(benefits, number).then(res => {
        if (res.code === 200) {
          if(res.data){
            return true;
          }
        } else {
          this.showDialogMsg(res.returnMsg);
          return false;
        }
      })
    },
    //获取当前登录人名下注册登记的球杆
    selectProductByUser(seriesId){
      seriesOfCueSticks(seriesId).then(res => {
        if (res.code === 200) {
          if(res.data){
            this.myClubList = res.data;
            this.selectOptions = res.data.map(item => item.value);
          }
        } else {
          this.showDialogMsg(res.returnMsg)
        }
      })
    },
    //手机号正则校验
    telValidator(val) {
      if(val){
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(val)) {
          return false;
        }
      }else{
        return false;
      }
    },
    //顶部标题栏返回事件
    onClickLeft() {
      this.$router.push('/app_benefits');
    },
    //序列号确认事件
    onConfirm(value) {
      this.formData.oldNumber = value;
      this.showPicker = false;
      this.selectClubForm = this.myClubList.filter(item => item.value === value)[0] ||[];
      if(this.selectClubForm){
        this.formData.oldBrandCode = this.selectClubForm.brandCode;
        this.formData.oldBrand = this.selectClubForm.brand;
        this.formData.oldModelCode = this.selectClubForm.modelCode;
        this.formData.oldModel = this.selectClubForm.model;
      }
    },
    //球杆品类确认事件
    onBenefitsConfirm(value, index) {
      const selectedItem = this.selectBenefitsOptions[index];
      this.showBenefitsPicker = false
      const flag = this.memberEquitiesUseCheck(selectedItem.value,this.formData.oldNumber);
      if(flag){
        const benefits = this.benefitsList.filter(item => item.id === selectedItem.value)[0]||[];
        if (benefits && benefits.isChildren) {
          this.isChildren = true;
        }else{
          this.isChildren = false;
        }
        if(selectedItem){
          this.formData.newId = selectedItem.value;
          this.formData.newName = selectedItem.text;
        }
        // this.showBenefitsPicker = false
      }
    },
    //球杆跨色品类确认事件
    onColorConfirm(value, index) {
      const selectedItem = this.selectColorOptions[index];
      this.showColorPicker = false
      const flag = this.memberEquitiesUseCheck(selectedItem.value,this.formData.oldNumber);
      if(flag && selectedItem){
        this.formData.colorId = selectedItem.value;
        this.formData.colorName = selectedItem.text;
      }
      this.showColorPicker = false
    },

    //提交申请
    async onSubmit(){

      const formData = new FormData();

      formData.append('phonenumber', this.formData.phonenumber);
      formData.append('address', this.formData.address); // 单选值，直接传
      formData.append('oldNumber', this.formData.oldNumber);
      formData.append('oldBrandCode', this.formData.oldBrandCode);
      formData.append('oldBrand', this.formData.oldBrand);
      formData.append('oldModelCode', this.formData.oldModelCode);
      formData.append('oldModel', this.formData.oldModel);
      formData.append('storeId', this.formData.storeId);
      if(this.formData.isColor == '1'){
        if(this.formData.colorId){
          formData.append('newId', this.formData.colorId);
        }
      }else{
        formData.append('newId', this.formData.newId);
      }
      formData.append('type', this.type);

      const files = [];
      this.formData.fileList.forEach(item => {
        if (item.file) {
          files.push(item.file);
          formData.append('file', item.file);
        }
      });
      const res = await benefitsSubmit(formData);
      if(res.code==200){
        Toast("提交申请成功，请您等待售后联系！")
        setTimeout(() => {
          this.$router.push({
            path: '/app_benefits',
          })
        }, 2000);

      }else{
        Toast(res.returnMsg)
      }
    },

    showDialogMsg(message){
      Dialog.alert({
        title: '查询结果',
        message: message,
        dangerouslyUseHTMLString: true
      });
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
::v-deep .van-tab__pane{
  color: #0f0f0f !important;
}
.van-radio--horizontal{
  margin-bottom: 10px;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  margin-bottom: 60px;
}
.batch-item {
  padding: 10px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 15px;
}
.submit-btn{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
}
</style>